import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-widget-info',
    templateUrl: './widget-info.component.html',
    styleUrls: ['widget-info.component.scss'],
})
export class WidgetInfoComponent {
    @Input() public value: number;
    @Input() public behavior: string;
    @Output() openRegistrationSidebar = new EventEmitter<void>();
    constructor(private readonly router: Router) {}

    public goTo(routeTarget: string) {
        this.router.navigate([routeTarget]);
    }

    public openDrawer(): void {
        this.openRegistrationSidebar.emit();
    }
    public onReceiveValue(receivedValue: number): void {
        this.value = receivedValue;
    }
}
